import { StringUtils } from './string-utils';
import { Injectable } from '@angular/core';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable()
export class MensagensService {


    constructor() { }

    public ErrorConfirm(title: string = 'Erro!', text: string = 'Ocorreu um erro') {
        // const options = {
        //     title: 'Abandonar o Atendimento?',
        //     text: 'Se você sair sem finalizar o atendimento, os dados não serão salvos.',
        //     type: 'warning',
        //     showCancelButton: true,
        //     allowOutsideClick: false,
        //     cancelButtonText: 'Não, voltar ao atendimento',
        //     confirmButtonColor: '#d33',
        //     cancelButtonColor: '#3085d6',
        //     confirmButtonText: 'Sim'
        // };
        const options = {
            title: title,
            text: text,
            type: 'error',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public Error(title: string = 'Erro!', text: string = 'Ocorreu um erro') {
        const options = {
            title: title,
            text: text,
            type: 'error',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public isNullOrEmpty(val): boolean {
        if (val === undefined || val === null || val.trim() === '') {
            return true;
        }
        return false;
    }

    recuperarMensagemErro(err: any) {
        console.log(err);
        if (err.status === 400) {
            if (this.isNullOrEmpty(err.error.message)) {
                return err.error;
            }
            return err.error.message;
        } else if (err.status === 404) {
            if (this.isNullOrEmpty(err.error)) {
                return 'Erro ao processar a requisição';
            }
            if (this.isNullOrEmpty(err.error.message)) {
                return err.error;
            }
            return err.error.message;
        } else if (err.status === 500) {
            if (this.isNullOrEmpty(err.error.message)) {
                return err.error;
            } else if (!this.isNullOrEmpty(err.error.exceptionMessage)) {
                return err.error.message + ' - ' + err.error.exceptionMessage;
            }
            return err.error.message;
        }
    }

    public SuccessConfirm(title: string = 'Sucesso!', text: string = 'Atualizado com sucesso!') {
        const options = {
            title: title,
            text: text,
            type: 'success',
            allowOutsideClick: false,
            confirmButtonText: 'OK'
        };
        Swal.fire(options);
    }

    public Success(title: string = 'Sucesso!', text: string = 'Atualizado com sucesso') {
        const options = {
            title: title,
            text: text,
            type: 'success',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public InfoConfirm(title: string = 'Atenção!', text: string = 'Atenção!') {
        const options = {
            title: title,
            text: text,
            type: 'info',
            confirmButtonText: 'OK',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public Info(title: string = 'Atenção!', text: string = 'Atenção') {
        const options = {
            title: title,
            text: text,
            type: 'info',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public WarningConfirm(title: string = 'Atenção!', text: string = 'Atenção!') {
        const options = {
            title: title,
            text: text,
            type: 'warning',
            confirmButtonText: 'OK',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public Warning(title: string = 'Atenção!', text: string = 'Atenção') {
        const options = {
            title: title,
            text: text,
            type: 'warning',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public HtmlMensagem(title: string = 'Atenção!', html: string) {
        const options = {
            title: title,
            html: html,
            allowEscapeKey: false,
            type: 'info',
            allowOutsideClick: false
        };
        Swal.fire(options);
    }

    public downloadBase64File(base64Data: string, fileName: string) {
        const base64 = base64Data.split(',')[1]; // remove o prefixo
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        // Tenta inferir o tipo MIME (pode ser genérico também)
        const blob = new Blob([byteArray], { type: this.getMimeTypeFromFilename(fileName) });

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();

        // Libera a URL da memória
        window.URL.revokeObjectURL(link.href);
    }

    public openBase64FileInNewTab(base64Data: string, fileName: string) {
        const base64 = base64Data.split(',')[1]; // Remove o prefixo (ex: data:application/pdf;base64,...)
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const mimeType = this.getMimeTypeFromFilename(fileName);
        const blob = new Blob([byteArray], { type: mimeType });

        const blobUrl = window.URL.createObjectURL(blob);

        // Abre em uma nova aba
        window.open(blobUrl, '_blank');

        // (Opcional) Libera a URL após um tempo para evitar uso de memória desnecessário
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 10000); // espera 10 segundos antes de revogar
    }

    getMimeTypeFromFilename(filename: string): string {
        const extension = filename.split('.').pop()?.toLowerCase();

        switch (extension) {
            case 'pdf': return 'application/pdf';
            case 'png': return 'image/png';
            case 'jpg':
            case 'jpeg': return 'image/jpeg';
            case 'txt': return 'text/plain';
            case 'doc': return 'application/msword';
            case 'docx': return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
            case 'xlsx': return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            default: return 'application/octet-stream'; // genérico
        }
    }
}
